import util from '../util'

let controller = 'Contas'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  GetDigito: function (numeroConta) {
    return util.Axios.Get(controller + '/GetDigito', numeroConta)
  },
  GetContaParceiroByContaPgto: function (contaPgto) {
    return util.Axios.Get(controller + '/GetContaParceiroByContaPgto', contaPgto)
  },
  GetContaAtivaPaginado: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/ContaAtivaPaginado',  dto)
  },
  GetContaSaldo: function (id) {
    return util.Axios.Get(controller + '/GetContaSaldo', id)
  },
  GetContaExtrato: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetContaExtrato', dto)
  },
  RelatorioSaldo: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/RelatorioSaldo', dto)
  },
  RelatorioSaldoPorParceiro: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/RelatorioSaldoConsolidadoPorParceiro', dto)
  },
  GetContaMovimentos: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/GetContaMovimentos', dto)
  },
  FecharConta: function (id) {
    return util.Axios.Put(controller + '/FecharConta', id)
  },
  ListarPorParceiroSomenteAtivas: function (dto) {
    return util.Axios.GetAll(controller + '/ListarPorParceiroSomenteAtivas', dto)
  },
  RelatorioContas: function (dto) {
    return util.Axios.GetAll(controller + '/RelatorioContas', dto)
  },
  MonitorMovimentacao: function (dto) {
    return util.Axios.GetAll(controller + '/MonitorMovimentacao', dto)
  },
  RelatorioDivergenciasCadastrais: function (dto) {
    return util.Axios.GetAll(controller + '/RelatorioDivergenciasCadastrais', dto)
  },
  PutDadosContabeis: function (id, dto) {
    return util.Axios.Put(controller + '/DadosContabeis', id, dto)
  },
  VerificarContaContabil: function (dto) {
    return util.Axios.GetAll(controller + '/VerificarContaContabil', dto)
  },
  SolicitarPermissaoCartao: function (id, dto) {
    return util.Axios.Put(controller + '/PermissaoSolicitacaoCartao', id, dto)
  },
  ComboContas: function (dto) {
    return util.Axios.GetAll(controller + '/ComboContas', dto)
  },
  GetById: function (id) {
    return util.Axios.Get(controller + '/' + id)
  },
  GetCodigoContaFavorecido: function (contaDto) {
    return util.Axios.GetAll(controller + '/GetCodigoContaFavorecido', contaDto, true)
  },
  GetContaPaginado: function (dto, options) {
    if (options && options.data) dto.data = options.data

    return util.Axios.GetAll(controller + '/GetContaPaginado', dto)
  },
  GetSolicitacoesEncerramento: function (dto) {
    return util.Axios.GetAll(controller + '/Encerramento', dto)
  },
  SolicitarEncerramentoConta: function (dto) {
    return util.Axios.Post(controller + '/Encerramento', dto)
  },
  CancelarSolicitacaoEncerramento: function (dto) {
    return util.Axios.Delete(controller + '/Encerramento', dto)
  },
  ConsultaSolicitacoesPendentes: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Encerramento/Pendentes', dto)
  },
  AprovarMultiplosEncerramentoConta: function (dto) {
    return util.Axios.Post(controller + '/Encerramento/AprovarMultiplos', dto)
  },
  AprovarEncerramentoConta: function (dto) {
    return util.Axios.Post(controller + '/Encerramento/Aprovar', dto)
  },
  RejeitarEncerramentoConta: function (dto) {
    return util.Axios.Post(controller + '/Encerramento/Rejeitar', dto)
  },
  HistoricoEncerramentoConta: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/Encerramento/Historico', dto)
  },
  MigracaoParceiro: function (dto) {
    return util.Axios.Post(controller + '/MigracaoParceiro', dto)
  },
  GetContasTransitorias: function () {
    return util.Axios.Get(controller + '/GetContasTransitorias')
  },
  SolicitarRelatorioMovConta: function (dto) {
    return util.Axios.Post(controller + '/SolicitarRelatorioMovConta', dto)
  },
  GetSeqArquivoCNAB: function (codigoConta, tipoArquivo) {
    return util.Axios.Get(controller + `/GetSeqContaCNAB/${codigoConta}/${tipoArquivo}`)
  },
  DetalhesContaCorrentista: function (id) {
    return util.Axios.Get(controller + '/DetalhesContaCorrentista', id)
  },
  CarregarArquivoEncerramentoContaLote: function (dto) {
    return util.Axios.Post(controller + '/EncerramentoContaLote/CarregarArquivo', dto)
  },
  BuscarSolicitacoesEncerramentoContaLote: function (dto) {
    return util.Axios.GetAll(controller + '/EncerramentoContaLote/BuscarSolicitacoes', dto)
  },
  BuscarLinhasArquivoEncerramentoContaLote: function (dto) {
    return util.Axios.GetAll(controller + '/EncerramentoContaLote/BuscarLinhasArquivo', dto)
  },
  EnviarParaEncerramentoContaLote: function (dto) {
    return util.Axios.Post(controller + '/EncerramentoContaLote/EnviarParaEncerramentoConta', dto)
  },
  ObterContasMigracao: function (dto) {
    return util.Axios.GetAll(controller + '/migracao', dto)
  },
  MigrarParceiroEmLote: function (dto) {
    return util.Axios.Post(controller + '/migracao/lote', dto)
  },
  AtualizarSituacaoBloqueioConta: function (dto) {
    return util.Axios.Patch(controller + '/bloqueio-conta/situacao', dto)
  },
  BuscarContasMigradas: function (dto, options) {
    if (options && options.data) dto.data = options.data
    return util.Axios.GetAll(controller + '/contas-migradas', dto)
  },
  AtualizarNotificacao: function (id, dto) {
    return util.Axios.Put(controller + '/AtualizarNotificacao', id, dto)
  },
  AtualizarHorarioAcesso: function(id, dto){
    return util.Axios.Put(controller + '/AtualizarHorarioAcesso', id, dto)
  },
  BuscarHistoricosBloqueios: function(dto){
    return util.Axios.GetAll(controller + '/bloqueio-conta/historico', dto)
  }
})
